/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

interface UiCardProps {
    children: React.ReactNode
    className?: string
    padding?: 'none' | 'sm' | 'md' | 'lg'
}

const UiCard = ({ children, className, padding = 'md' }: UiCardProps) => {
    const paddings = {
        none: 'p-0',
        sm: 'p-3',
        md: 'p-5',
        lg: 'p-8',
    }

    return (
        <div
            className={clsx(
                'UiCard bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm overflow-hidden',
                paddings[padding],
                className
            )}
        >
            {children}
        </div>
    )
}

export const UiCardHeader = ({
    children,
    className,
}: {
    children: React.ReactNode
    className?: string
}) => (
    <div className={clsx('mb-1 flex items-center pb-2 border-b border-gray-100 dark:border-gray-700 justify-between', className)}>
        {children}
    </div>
)

export const UiCardTitle = ({
    children,
    className,
}: {
    children: React.ReactNode
    className?: string
}) => (
    <h3
        className={clsx(
            'text-lg font-semibold text-gray-900 dark:text-white',
            className
        )}
    >
        {children}
    </h3>
)

export const UiCardContent = ({
    children,
    className,
}: {
    children: React.ReactNode
    className?: string
}) => <div className={clsx('space-y-4', className)}>{children}</div>

export default UiCard
